var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import EventEmitter from 'events';
import { logger } from './logger';
import { isMediaDeniedError, isMediaDismissedError, isSystemPermissionsError, } from './mediaErrors';
import { MediaLocalTracks } from './MediaLocalTracks';
import { MediaState, TrackType, } from './MediaProvider';
import { LocalStoragePreferredDeviceStorage, } from './PreferredDeviceStorage';
var MediaService = /** @class */ (function (_super) {
    __extends(MediaService, _super);
    function MediaService(_a) {
        var _b, _c;
        var providers = _a.providers, tokenProvider = _a.tokenProvider, _d = _a.preferredDeviceStorage, preferredDeviceStorage = _d === void 0 ? new LocalStoragePreferredDeviceStorage() : _d, _e = _a.localMicVolumeThreshold, localMicVolumeThreshold = _e === void 0 ? 0.002 : _e, defaultCameraConstraints = _a.defaultCameraConstraints, defaultMicrophoneConstraints = _a.defaultMicrophoneConstraints, defaultScreenConstraints = _a.defaultScreenConstraints;
        var _this = _super.call(this) || this;
        _this._activeProviderName = 'PopStage';
        _this._preferredDeviceId = (_b = {},
            _b[TrackType.Camera] = null,
            _b[TrackType.Microphone] = null,
            _b);
        _this._mediaDevices = [];
        _this._isStartingMediaType = (_c = {},
            _c[TrackType.Camera] = false,
            _c[TrackType.Microphone] = false,
            _c[TrackType.Screen] = false,
            _c[TrackType.ScreenAudio] = false,
            _c);
        _this.participantSpeakingStates = new Map();
        _this._hasStartedAnyDevice = false;
        /**
         * Call to connect to a media provider. If the service is already connected
         * to a different provider, it will switch providers.
         */
        _this.connect = function (connectionParams) { return __awaiter(_this, void 0, void 0, function () {
            var token;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.providers[connectionParams.providerName]) {
                            throw new Error("No media provider named \"".concat(connectionParams.providerName, "\" exists"));
                        }
                        return [4 /*yield*/, this.tokenProvider.getToken(connectionParams)];
                    case 1:
                        token = _b.sent();
                        this.emit('providerChanged', {
                            token: token,
                            providerName: connectionParams.providerName,
                        });
                        return [4 /*yield*/, ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.disconnect())];
                    case 2:
                        _b.sent();
                        this.cleanupProviderEvents();
                        this._activeProviderName = connectionParams.providerName;
                        if (!this.activeProvider) {
                            throw new Error("Failed to start provider [".concat(connectionParams.providerName, "]"));
                        }
                        this.handleProviderEvents(this.activeProvider);
                        return [4 /*yield*/, this.activeProvider.connect(token, this.localTracks.tracks)];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.cleanupProviderEvents = function () { };
        _this.createEcho = function (eventType) {
            return function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                logger.debug.apply(logger, __spreadArray(['[Media] ', eventType], __read(params), false));
                _this.emit.apply(_this, __spreadArray([eventType], __read(params), false));
            };
        };
        _this.handleProviderEvents = function (provider) {
            var echoCancels = new Array();
            [
                'connecting',
                'connected',
                'disconnected',
                'reconnecting',
                'error',
                'warning',
                'trackStarted',
                'trackStopped',
                'remoteTrackStarted',
                'remoteTrackStopped',
                'participantConnected',
                'participantDisconnected',
            ].forEach(function (eventType) {
                var echo = _this.createEcho(eventType);
                provider.on(eventType, echo);
                echoCancels.push(function () { return provider.off(eventType, echo); });
            });
            provider.on('trackStopped', _this.handleTrackStopped);
            provider.on('message', _this.handleMessage);
            _this.cleanupProviderEvents = function () {
                echoCancels.forEach(function (cancel) { return cancel(); });
                provider.off('trackStopped', _this.handleTrackStopped);
                provider.off('message', _this.handleMessage);
            };
        };
        _this.disconnect = function (endStreams) {
            if (endStreams === void 0) { endStreams = true; }
            return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.disconnect())];
                        case 1:
                            _b.sent();
                            if (endStreams) {
                                this.localTracks.stopAll();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        /** Media device management */
        _this.syncMediaDevices = function () {
            if (typeof navigator !== 'undefined' && 'mediaDevices' in navigator) {
                navigator.mediaDevices
                    .enumerateDevices()
                    .then(function (devices) {
                    _this._mediaDevices = devices;
                    _this.emit('mediaDevicesChanged', devices);
                })
                    .catch(function (err) {
                    _this.emit('error', err);
                });
            }
        };
        _this.setPreferredCameraDeviceId = function (deviceId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._preferredDeviceId[TrackType.Camera] = deviceId;
                        this.preferredDeviceStorage.setDeviceId(TrackType.Camera, deviceId);
                        this.emit('preferredCameraDeviceIdChanged', deviceId);
                        if (!this.localTracks.cameraTrack) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.stopCamera()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.startCamera()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.setPreferredMicrophoneDeviceId = function (deviceId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._preferredDeviceId[TrackType.Microphone] = deviceId;
                        this.preferredDeviceStorage.setDeviceId(TrackType.Microphone, deviceId);
                        this.emit('preferredMicrophoneDeviceIdChanged', deviceId);
                        if (!this.localTracks.microphoneTrack) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.stopMicrophone()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.startMicrophone()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.startCamera = function (constraints) {
            if (constraints === void 0) { constraints = _this._defaultCameraConstraints; }
            return __awaiter(_this, void 0, void 0, function () {
                var track, error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this._isStartingMediaType[TrackType.Camera]) {
                                return [2 /*return*/];
                            }
                            this._isStartingMediaType[TrackType.Camera] = true;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, 5, 6]);
                            return [4 /*yield*/, this.localTracks.startCamera(this._preferredDeviceId[TrackType.Camera], constraints)];
                        case 2:
                            track = _b.sent();
                            return [4 /*yield*/, ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.startMediaInternal(TrackType.Camera, track))];
                        case 3:
                            _b.sent();
                            this._isStartingMediaType[TrackType.Camera] = false;
                            this.emit('localTrackStarted', TrackType.Camera);
                            if (!this._hasStartedAnyDevice) {
                                this._hasStartedAnyDevice = true;
                                this.syncMediaDevices();
                            }
                            return [3 /*break*/, 6];
                        case 4:
                            error_1 = _b.sent();
                            if (isMediaDeniedError(error_1) ||
                                isMediaDismissedError(error_1) ||
                                isSystemPermissionsError(error_1)) {
                                this.emit('deviceAccessDenied', TrackType.Camera, error_1);
                            }
                            throw error_1;
                        case 5:
                            this._isStartingMediaType[TrackType.Camera] = false;
                            return [7 /*endfinally*/];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        _this.stopCamera = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.localTracks.stopCamera();
                        return [4 /*yield*/, ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.stopMediaInternal(TrackType.Camera))];
                    case 1:
                        _b.sent();
                        this._isStartingMediaType[TrackType.Camera] = false;
                        this.emit('localTrackStopped', TrackType.Camera);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.startMicrophone = function (constraints) {
            if (constraints === void 0) { constraints = _this._defaultMicrophoneConstraints; }
            return __awaiter(_this, void 0, void 0, function () {
                var track, error_2;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this._isStartingMediaType[TrackType.Microphone]) {
                                return [2 /*return*/];
                            }
                            this._isStartingMediaType[TrackType.Microphone] = true;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, 5, 6]);
                            return [4 /*yield*/, this.localTracks.startMicrophone(this._preferredDeviceId[TrackType.Microphone], constraints)];
                        case 2:
                            track = _b.sent();
                            return [4 /*yield*/, ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.startMediaInternal(TrackType.Microphone, track))];
                        case 3:
                            _b.sent();
                            this._isStartingMediaType[TrackType.Microphone] = false;
                            this.emit('localTrackStarted', TrackType.Microphone);
                            if (!this._hasStartedAnyDevice) {
                                this._hasStartedAnyDevice = true;
                                this.syncMediaDevices();
                            }
                            return [3 /*break*/, 6];
                        case 4:
                            error_2 = _b.sent();
                            if (isMediaDeniedError(error_2) ||
                                isMediaDismissedError(error_2) ||
                                isSystemPermissionsError(error_2)) {
                                this.emit('deviceAccessDenied', TrackType.Camera, error_2);
                            }
                            else {
                                throw error_2;
                            }
                            return [3 /*break*/, 6];
                        case 5:
                            this._isStartingMediaType[TrackType.Microphone] = false;
                            return [7 /*endfinally*/];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        _this.stopMicrophone = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.localTracks.stopMicrophone();
                        return [4 /*yield*/, ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.stopMediaInternal(TrackType.Microphone))];
                    case 1:
                        _b.sent();
                        this._isStartingMediaType[TrackType.Microphone] = false;
                        this.emit('localTrackStopped', TrackType.Microphone);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.startScreenShare = function (constraints) {
            if (constraints === void 0) { constraints = _this._defaultScreenConstraints; }
            return __awaiter(_this, void 0, void 0, function () {
                var tracks, promises, error_3;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this._isStartingMediaType[TrackType.Screen]) {
                                return [2 /*return*/];
                            }
                            this._isStartingMediaType[TrackType.Screen] = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, 6, 7]);
                            return [4 /*yield*/, this.localTracks.startScreenShare(constraints)];
                        case 2:
                            tracks = _a.sent();
                            // not ideal to fire this after the getUserMedia, but there's no way
                            // to know whether the user ticks the audio box or not before...
                            if (tracks.audio) {
                                this._isStartingMediaType[TrackType.ScreenAudio] = true;
                            }
                            if (!this.activeProvider) return [3 /*break*/, 4];
                            promises = [];
                            promises.push(this.activeProvider
                                .startMediaInternal(TrackType.Screen, tracks.video)
                                .then(function () {
                                _this._isStartingMediaType[TrackType.Screen] = false;
                                _this.emit('localTrackStarted', TrackType.Screen);
                            }));
                            if (tracks.audio) {
                                promises.push(this.activeProvider
                                    .startMediaInternal(TrackType.Screen, tracks.audio)
                                    .then(function () {
                                    _this._isStartingMediaType[TrackType.ScreenAudio] = false;
                                    _this.emit('localTrackStarted', TrackType.ScreenAudio);
                                }));
                            }
                            return [4 /*yield*/, Promise.all(promises)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [3 /*break*/, 7];
                        case 5:
                            error_3 = _a.sent();
                            if (isMediaDeniedError(error_3) ||
                                isMediaDismissedError(error_3) ||
                                isSystemPermissionsError(error_3)) {
                                this.emit('deviceAccessDenied', TrackType.Screen, error_3);
                            }
                            else {
                                throw error_3;
                            }
                            return [3 /*break*/, 7];
                        case 6:
                            this._isStartingMediaType[TrackType.Screen] = false;
                            this._isStartingMediaType[TrackType.ScreenAudio] = false;
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        };
        _this.stopScreenShare = function () { return __awaiter(_this, void 0, void 0, function () {
            var isStreamingAudio;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isStreamingAudio = !!this.localTracks.screenAudioTrack;
                        this.localTracks.stopScreenShare();
                        return [4 /*yield*/, ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.stopMediaInternal(TrackType.Screen))];
                    case 1:
                        _b.sent();
                        this._isStartingMediaType[TrackType.Screen] = false;
                        this._isStartingMediaType[TrackType.ScreenAudio] = false;
                        this.emit('localTrackStopped', TrackType.Screen);
                        if (isStreamingAudio) {
                            this.emit('localTrackStopped', TrackType.ScreenAudio);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.stopTrack = function (track) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = track;
                        switch (_a) {
                            case TrackType.Camera: return [3 /*break*/, 1];
                            case TrackType.Microphone: return [3 /*break*/, 3];
                            case TrackType.Screen: return [3 /*break*/, 5];
                            case TrackType.ScreenAudio: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, this.stopCamera()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 3: return [4 /*yield*/, this.stopMicrophone()];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.stopScreenShare()];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        _this.getParticipantTrack = function (participantId, trackType) {
            var _a;
            return (_a = _this.activeProvider) === null || _a === void 0 ? void 0 : _a.getParticipantTrack(participantId, trackType);
        };
        _this.getLocalTrack = function (trackType) {
            return _this.localTracks.tracks[trackType];
        };
        _this.getParticipantIds = function () {
            var _a;
            return ((_a = _this.activeProvider) === null || _a === void 0 ? void 0 : _a.getParticipantIds()) || [];
        };
        _this.getParticipantSpeakingState = function (participantId) {
            var _a;
            return (_a = _this.participantSpeakingStates.get(participantId)) !== null && _a !== void 0 ? _a : false;
        };
        _this.handleLocalSpeakingChange = function (isSpeaking) {
            var _a;
            if (!_this.localParticipantId)
                return;
            _this.participantSpeakingStates.set(_this.localParticipantId, isSpeaking);
            _this.emit('participantSpeakingStateChanged', _this.localParticipantId, isSpeaking);
            (_a = _this.activeProvider) === null || _a === void 0 ? void 0 : _a.broadcastMessage(serializeSpeakingStateMessage(_this.localParticipantId, isSpeaking));
        };
        _this.handleMessage = function (sourceParticipantId, message) {
            if (message.startsWith('speaking:')) {
                var _a = deserializeSpeakingStateMessage(message), participantId = _a.participantId, status_1 = _a.status;
                _this.participantSpeakingStates.set(participantId, status_1);
                _this.emit('participantSpeakingStateChanged', participantId, status_1);
            }
            else {
                // public facing message
                _this.emit('message', sourceParticipantId, message);
            }
        };
        _this.handleTrackStopped = function (participantId, track) {
            _this.participantSpeakingStates.set(participantId, false);
            _this.emit('participantSpeakingStateChanged', participantId, false);
        };
        _this.broadcastMessage = function (message) {
            var _a;
            (_a = _this.activeProvider) === null || _a === void 0 ? void 0 : _a.broadcastMessage(message);
        };
        _this.providers = providers;
        _this.tokenProvider = tokenProvider;
        _this.preferredDeviceStorage = preferredDeviceStorage;
        _this._defaultCameraConstraints = defaultCameraConstraints;
        _this._defaultMicrophoneConstraints = defaultMicrophoneConstraints;
        _this._defaultScreenConstraints = defaultScreenConstraints;
        _this.localTracks = new MediaLocalTracks(localMicVolumeThreshold);
        // re-emit local track events
        _this.localTracks.on('trackStarting', function (trackType) {
            _this.emit('localTrackStarting', trackType);
        });
        _this.localTracks.on('trackStopping', function (trackType) {
            _this.emit('localTrackStopping', trackType);
        });
        // sync media devices when permissions change
        if (typeof window !== 'undefined') {
            _this._preferredDeviceId[TrackType.Camera] =
                _this.preferredDeviceStorage.getDeviceId(TrackType.Camera) || null;
            _this._preferredDeviceId[TrackType.Microphone] =
                _this.preferredDeviceStorage.getDeviceId(TrackType.Microphone) || null;
            _this.syncMediaDevices();
            // Safari!
            if (typeof navigator !== 'undefined' && 'permissions' in navigator) {
                navigator.permissions
                    .query({
                    name: 'camera',
                })
                    .then(function (permissionStatus) {
                    permissionStatus.addEventListener('change', _this.syncMediaDevices);
                })
                    .catch(function (err) {
                    // ignore - sorry FireFox.
                });
                navigator.permissions
                    .query({
                    name: 'microphone',
                })
                    .then(function (permissionStatus) {
                    permissionStatus.addEventListener('change', _this.syncMediaDevices);
                })
                    .catch(function (err) {
                    // ignore - sorry FireFox.
                });
            }
        }
        _this.localTracks.on('localMicVolumeThresholdChange', _this.handleLocalSpeakingChange);
        return _this;
    }
    Object.defineProperty(MediaService.prototype, "providerName", {
        get: function () {
            return this._activeProviderName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaService.prototype, "activeProvider", {
        get: function () {
            return this.providers[this._activeProviderName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaService.prototype, "mediaState", {
        get: function () {
            var _a;
            return ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.mediaState) || MediaState.Disconnected;
        },
        enumerable: false,
        configurable: true
    });
    MediaService.prototype.getMediaDevices = function (trackType) {
        if (!trackType) {
            return this._mediaDevices;
        }
        return this._mediaDevices.filter(function (dev) {
            return trackType === TrackType.Camera
                ? dev.kind === 'videoinput'
                : dev.kind === 'audioinput';
        });
    };
    MediaService.prototype.getPreferredCameraDeviceId = function () {
        return this._preferredDeviceId[TrackType.Camera];
    };
    MediaService.prototype.getPreferredMicrophoneDeviceId = function () {
        return this._preferredDeviceId[TrackType.Microphone];
    };
    MediaService.prototype.getIsLocalTrackStarting = function (trackType) {
        return this._isStartingMediaType[trackType];
    };
    Object.defineProperty(MediaService.prototype, "localParticipantId", {
        get: function () {
            var _a;
            return ((_a = this.activeProvider) === null || _a === void 0 ? void 0 : _a.localParticipantId) || null;
        },
        enumerable: false,
        configurable: true
    });
    return MediaService;
}(EventEmitter));
export { MediaService };
function serializeSpeakingStateMessage(participantId, status) {
    return "speaking:".concat(participantId, ":").concat(status);
}
function deserializeSpeakingStateMessage(message) {
    var _a = __read(message.split(':'), 3), participantId = _a[1], status = _a[2];
    return { participantId: participantId, status: status === 'true' };
}
//# sourceMappingURL=MediaService.js.map